import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { setToastData } from "../../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../../Services/Common";
import Select from "react-select";

const AssignRoles = () => {
    const dispatch = useDispatch();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [membersList, setmembersList] = useState([]);
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
    });
    const [srAsCmd,setAsAsCmd] = useState([]);
    const [assCmd,setAssCmd] = useState([]);
    const [majorLs,setMajorLs] = useState([]);
    const [viceCaptainLs,setViceCapLs] = useState([]);
    const [grpLdrLs,setGrpLdLs] = useState([]);
    const [assGrpLdrLs,setAssGrpLdLs] = useState([]);
    const [divAdLs,setDivAddLs] = useState([]);
    useEffect(() => {
        dispatch(setPageTitle('Assign Roles'));
        let promiseArray = [];
        dispatch(setMainLoading(true));
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {

            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
        else{
            fetchMembersList();
        }
    }, [accessToken, dispatch]);
    const fetchMembersList = () => {
        setmembersList([]);
        setAsAsCmd([]);
        setAssCmd([]);
        setMajorLs([]);
        setViceCapLs([]);
        setGrpLdLs([]);
        setAssGrpLdLs([]);
        setDivAddLs([]);
        if (filter.div_id > 0) {
            dispatch(setMainLoading(true));
            let postData = {
                ...filter,
                search: ''
            }
            postData.page = 0
            postData.perPage = 1000
            Promise.all([
                PostAxios(`users`, postData, accessToken),
                PostAxios(`users/div-hierarchy`, { div_id: filter.div_id }, accessToken)
            ])
                .then((response) => {
                    let userResponse = response[0].data;
                    let heirarchyResponse = response[1].data;
                    if (userResponse.status === "1") {
                        let tempMemberList = [];
                        if (userResponse.data.length > 0) {
                            for (let ml of userResponse.data) {
                                if(`${ml?.user_title_prefix}${ml?.first_name}${ml?.user_last_name}` !== ""){
                                    tempMemberList.push({ value: ml.id, label: `${ml?.full_name.trim()}` })
                                }
                            }
                            setmembersList(tempMemberList);
                        }
                    }
                    else {
                        dispatch(setToastData({
                            message: (userResponse.errors) ? ConvertErrorArrayToString(userResponse.errors) : userResponse.message,
                            isHtml: true,
                            type: 'error',
                            showCloseBtn: true
                        }))
                    }
                    if (heirarchyResponse.status === "1") {
                        if(heirarchyResponse.data.sr_asst_cmd.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.sr_asst_cmd) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setAsAsCmd(tempLs);
                        }
                        if(heirarchyResponse.data.asst_cmd.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.asst_cmd) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setAssCmd(tempLs);
                        }
                        if(heirarchyResponse.data.major.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.major) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setMajorLs(tempLs);
                        }
                        if(heirarchyResponse.data.vice_captain.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.vice_captain) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setViceCapLs(tempLs);
                        }
                        if(heirarchyResponse.data.grp_leader.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.grp_leader) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setGrpLdLs(tempLs);
                        }
                        if(heirarchyResponse.data.ass_grp_leader.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.ass_grp_leader) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setAssGrpLdLs(tempLs);
                        }
                        if(heirarchyResponse.data.div_admin.length > 0){
                            let tempLs = [];
                            for (let ml of heirarchyResponse.data.div_admin) {
                                tempLs.push({ value: ml.id, label: `${ml?.user_title_prefix} ${ml?.first_name} ${ml?.last_name}` })
                            }
                            setDivAddLs(tempLs);
                        }
                    }
                    else {
                        dispatch(setToastData({
                            message: (heirarchyResponse.errors) ? ConvertErrorArrayToString(heirarchyResponse.errors) : heirarchyResponse.message,
                            isHtml: true,
                            type: 'error',
                            showCloseBtn: true
                        }))
                    }
                })
                .catch(err => {
                    responseCatchFunc(dispatch, err)
                }).finally(() => {
                    dispatch(setMainLoading(false));
                })
        }
    }
    useEffect(() => {
        fetchMembersList();
    }, [filter.div_id])
    return (
        <div className="main-form-sec">
            <Formik
                initialValues={{
                    org_id: filter.org_id,
                    div_id: filter.div_id,
                    sr_asst_cmd: srAsCmd,
                    asst_cmd: assCmd,
                    major: majorLs,
                    vice_captain: viceCaptainLs,
                    grp_leader: grpLdrLs,
                    ass_grp_leader: assGrpLdrLs,
                    div_admin: divAdLs
                }}
                enableReinitialize={true}
                onSubmit={(values,{setSubmitting,resetForm})=>{
                    setSubmitting(true);
                    dispatch(setMainLoading(false));
                    let postData = {
                        org_id:values.org_id,
                        div_id : values.div_id
                    }
                    if(values.sr_asst_cmd.length > 0){
                        let tempVals = [];
                        for(let sc of values.sr_asst_cmd){
                            tempVals.push(sc.value);
                        }
                        postData.sr_asst_cmd = tempVals.join(',');
                    }
                    if(values.asst_cmd.length > 0){
                        let tempVals = [];
                        for(let sc of values.asst_cmd){
                            tempVals.push(sc.value);
                        }
                        postData.asst_cmd = tempVals.join(',');
                    }
                    if(values.major.length > 0){
                        let tempVals = [];
                        for(let sc of values.major){
                            tempVals.push(sc.value);
                        }
                        postData.major = tempVals.join(',');
                    }
                    if(values.vice_captain.length > 0){
                        let tempVals = [];
                        for(let sc of values.vice_captain){
                            tempVals.push(sc.value);
                        }
                        postData.vice_captain = tempVals.join(',');
                    }
                    if(values.grp_leader.length > 0){
                        let tempVals = [];
                        for(let sc of values.grp_leader){
                            tempVals.push(sc.value);
                        }
                        postData.grp_leader = tempVals.join(',');
                    }
                    if(values.ass_grp_leader.length > 0){
                        let tempVals = [];
                        for(let sc of values.ass_grp_leader){
                            tempVals.push(sc.value);
                        }
                        postData.ass_grp_leader = tempVals.join(',');
                    }
                    if(values.div_admin.length > 0){
                        let tempVals = [];
                        for(let sc of values.div_admin){
                            tempVals.push(sc.value);
                        }
                        postData.div_admin = tempVals.join(',');
                    }
                    PostAxios(`users/assign-roles`,
                        {
                            ...postData
                        },
                        accessToken
                    )
                    .then(({data})=>{
                        if(data.status === "1"){
                            dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }));
                        }
                        else{
                            dispatch(setToastData({ message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                        }
                    })
                    .catch(err=>{
                        responseCatchFunc(dispatch,err)
                    })
                    .finally(()=>{
                        dispatch(setMainLoading(false));
                        setSubmitting(false);
                    })
                }}
                >
                {({ errors, touched, isSubmitting, handleChange, setFieldValue, values }) => (
                    <Form>
                        <div className="form-sec">
                            {
                                userData.role_slug === "super_admin" &&
                                <div className={`form-field-group w-50 ${(errors.org_id && touched.org_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="org_id">Organization</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="org_id" as="select" className="select-input" onChange={(e) => {
                                                if (e.target.value === "0") {
                                                    setFieldValue('div_id', 0);
                                                }
                                                handleChange(e);
                                                setFilter({ ...filter, org_id: e.target.value });
                                            }}>
                                                <option value="0">Choose Organization</option>
                                                {
                                                    orgList.length > 0 && orgList.map((item, index) => {
                                                        return <option value={item.ID} key={`org-list-${item.ID}`}>{item.short_name}</option>
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="org_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                <div className={`form-field-group w-50 ${(errors.div_id && touched.div_id) ? 'error-input' : ''}`}>
                                    <div className="w-50">
                                        <label htmlFor="div_id">Mohallah</label>
                                    </div>
                                    <div className="w-50">
                                        <label className="select-input-outer select-100">
                                            <Field name="div_id" as="select" className="select-input" onChange={(e) => {
                                                handleChange(e);
                                                setFilter({ ...filter, div_id: e.target.value });
                                            }} >
                                                <option value="0">Choose Mohallah</option>
                                                {
                                                    divList.length > 0 && divList.map((item, index) => {
                                                        if (parseInt(item.org_id) === parseInt(values.org_id)) {
                                                            return <option value={item.ID} key={`div-list-${item.ID}-${index}`}>{item.division_name} {`(${item.division_number})`}</option>
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Field>
                                        </label>
                                        <ErrorMessage component="span" name="div_id" className="error-label" />
                                    </div>
                                </div>
                            }
                            {
                                membersList.length > 0 && <>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="sr_asst_cmd">Sr. Assitant Commander</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Sr. Assitant Commander"
                                                value={values.sr_asst_cmd}
                                                onChange={(values) => {
                                                    setFieldValue('sr_asst_cmd', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="asst_cmd">Assitant Commander</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Assitant Commander"
                                                value={values.asst_cmd}
                                                onChange={(values) => {
                                                    setFieldValue('asst_cmd', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="major">Major</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Major"
                                                value={values.major}
                                                onChange={(values) => {
                                                    setFieldValue('major', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="vice_captain">Vice Captain</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Vice Captain"
                                                value={values.vice_captain}
                                                onChange={(values) => {
                                                    setFieldValue('vice_captain', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="grp_leader">Group Leader</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Group Leader"
                                                value={values.grp_leader}
                                                onChange={(values) => {
                                                    setFieldValue('grp_leader', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="ass_grp_leader">Asst. Group Leader</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Asst. Group Leader"
                                                value={values.ass_grp_leader}
                                                onChange={(values) => {
                                                    setFieldValue('ass_grp_leader', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className={`form-field-group w-50`}>
                                        <div className="w-50">
                                            <label htmlFor="div_admin">Division Admin</label>
                                        </div>
                                        <div className="w-50 input-area text-left">
                                            <Select
                                                options={membersList}
                                                placeholder="Choose Division Admin"
                                                value={values.div_admin}
                                                onChange={(values) => {
                                                    setFieldValue('div_admin', values);
                                                }}
                                                isSearchable={true}
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                    <div className="btm-right-btn justify-content-center my-3">
                                        <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Submit</button>
                                    </div>
                                </>
                            }
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default AssignRoles;